<template>
    <div class="artcleMain">
        <p class="current">当前位置：<span>{{ currentName }}</span></p>
        <div class="artcle-box">
            <div class="menu">
            <!-- default-active="0" -->
                <el-menu
            
                    class="el-menu-vertical-demo"
                    default-active='1'
                    background-color="#fff"
                    active-text-color="#00a8a8">
                        <el-menu-item index="1" @click="ClickArry()">全部</el-menu-item>
                        <el-menu-item v-for="item,index in maintypeData" :key="item.cate_id" :index="2+index.toString()" @click="handleListarticle(item)">
                            <!-- <i class="el-icon-menu"></i> -->
                            <span slot="title">{{ item.cate_name }}</span>
                        </el-menu-item>
                
                </el-menu>
            </div>
            <div class="artcle-right">
                <Search style="margin-bottom: 40px;width: 600px;" @inputKey="inputKey"></Search>
                <div v-for="item in listarticle" :key="item.id">
                    <div class="content-div" @click="handleDetail(item)">
                        <img :src="item.firstFile.FileUrl" alt="" v-show="item.firstFile.FileUrl">
                        <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl">
                        <div>
                            <p class="title-p">{{ item.title }}</p>
                            <p class="time-p">{{ item.create_time }}</p>
                            
                        </div>
                        
                    </div>
                    <el-divider   ></el-divider>
                </div>
                <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Search from "../search/index.vue"
export default({
    data(){
        return{
            innerWidth: '',
            input: '',
            // ListArticle:[],
            total: 0,
            hideOnSinglePage: true,
            currentChange: 1,
            cate_values: ['maintype','industry'],
            maintypeData:[],
            listarticle: [],
            channel: sessionStorage.getItem("channel"),
            maintype_ids: '',
            currentName: '',
            Newkeywords:'',
            widthNew: false
        }
    },
    components: {
        Search,
    },
    watch: {
        maintype_ids(newVal,lodVal){
            console.log("新值");
            console.log(newVal);
            this.maintype_ids = newVal
            sessionStorage.setItem('typeId',newVal);
            this.currentName = sessionStorage.getItem("name")
            let data = {
                channel: sessionStorage.getItem("channel"),
                pageNum: 1,
                pageSize: 20,
                maintype_ids: newVal,
                keywords: ''
            }
            this.getListArry(data)
            // console.log("!!!!!!!!!!!!!!!!!!!!");
            // console.log(data);
        }
        // '$options.maintype_ids': function (newChannel, oldChannel) {
        // // 在 sessionStorage.getItem("channel") 发生变化时执行操作
        //     console.log('sessionStorage channel changed:', newChannel);

            // let data = {
            //     channel: sessionStorage.getItem("channel"),
            //     pageNum: 1,
            //     pageSize: 20,
            //     maintype_ids: sessionStorage.getItem("typeId"),
            //     keywords: ''
            // }
            // this.getListArry(data)
        // }
    },
    methods:{
         //   获取菜单
        getMenuList(){
            const data = {
                pageNum: 1,
                pageSize: 999999,
                cate_values: this.cate_values
            }
            this.$store.dispatch('menu/menuList', data)
                .then((res) => {
                    console.log(res);
                    this.maintypeData = []
                    if(res.ok){
                        const list = res.data.items
                        list.forEach(item => {
                            if(item.p_cate_value == 'maintype'){
                                this.maintypeData.push(item)
                            }
                        });
                    }
                
                })
                .catch((err) => {
                    
                    console.log(err);
                }) 
        },
        getTimeDate(timeDate){
            const year = timeDate.getFullYear();
                const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
                const day = timeDate.getDate().toString().padStart(2, '0');
                const hours = timeDate.getHours().toString().padStart(2, '0');
                const minutes = timeDate.getMinutes().toString().padStart(2, '0');
                const seconds = timeDate.getSeconds().toString().padStart(2, '0');
                const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

                return formattedDate
        },
        //   根据不同的channel来查询
        getListArry(data){
            this.$store.dispatch('menu/getMenu',data)
                .then(res => {
                
                    if(res.ok){
                        this.listarticle = res.data.items
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                    
                    console.log("?????????????????????????");
                    console.log(this.listarticle);
                    this.listarticle.map(item => {
                        const timeDate = new Date(item.create_time)
                        item.create_time = this.getTimeDate(timeDate)
                    })


                }).catch(err => {
                    console.log(err);s
                })
        },

        ClickArry(){
            const data = {
                channel: this.channel,
                pageNum: 1,
                pageSize: 20,
                maintype_ids: '',
                keywords: '',
            }
            this.getListArry(data)
        },
        handleListarticle(value){
            let data = {
                channel: this.channel,
                pageNum: 1,
                pageSize: 20,
                maintype_ids: value.cate_id,
                keywords: ''
            }
            this.currentName = value.cate_name
            this.maintype_ids= value.cate_id,
            // sessionStorage.setItem("currentName",this.currentName) 
            this.getListArry(data)
            // console.log("cesereftrt");
            // console.log(value);
            // value.items.forEach(item => {
            //     item.create_time = new Date(parseInt(("/Date("+item.create_time+")/").substr(6, 13))).toLocaleDateString();

            // });

            // this.ListArticle = value.items
            // this.total = value.total
            // if(this.total <= 20){
            //     this.hideOnSinglePage = true
            // }else{
            //     this.hideOnSinglePage = false
            // }
        },

        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            this.currentChange = val
            let data = {
                channel: this.channel,
                pageNum: val,
                pageSize: 20,
                maintype_ids: this.maintype_ids,
                keywords: this.Newkeywords
            }
            this.getListArry(data)
        },
        handleDetail(item){
            
            const { href } = this.$router.resolve({
                path: "/detailPages",
                query: {
                    key: item.id,
                    currentName: this.currentName
                }
            });
            window.open(href, '_blank');
        },
        inputKey(val){
            this.Newkeywords = val
            let data = {
                channel: this.channel,
                pageNum: 1,
                pageSize: 20,
                maintype_ids: this.maintype_ids,
                keywords: val
            }

            this.getListArry(data)
        }
    },
    mounted(){
        this.currentName = sessionStorage.getItem("name")
        this.maintype_ids = sessionStorage.getItem("typeId")
        this.channel = sessionStorage.getItem("channel")

        // this.$options.storageChannel = sessionStorage.getItem("channel");
        // this.$options.maintype_ids = sessionStorage.getItem("typeId");s
        // this.$options.storageName = sessionStorage.getItem("name");
        let data = {
            channel: this.channel,
            pageNum: 1,
            pageSize: 20,
            maintype_ids: this.maintype_ids,
            keywords: ''
        }
        
        console.log("yyyyyyyyyyyyyyyyyyyy");
        console.log(data);
        this.getListArry(data)
        window.addEventListener('setItem', ()=> {
            this.maintype_ids = sessionStorage.getItem('typeId');
        })
   
    },
    
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        this.getMenuList()
        
       
    }
})
</script>

<style>
@import url(../../css/channelPolicy.css);
</style>